export default class OperationLogsClient {
    constructor(axios) {
        this.axios = axios;
    }
    async getAll() {
        const result = await this.axios.get("/operationLogs");
        return result.data;
    }
    async getOne(id) {
        const result = await this.axios.get(`/operationLogs/${id}`);
        return result.data;
    }
}
//# sourceMappingURL=OperationLogsClient.js.map